import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/brands')({
  component: BrandsLayout,
});

function BrandsLayout() {
  return <Outlet />;
}
